<template>
  <div class="grid grid-cols-2 gap-1 h-full overflow-scroll pb-8">
    <div v-for="layout in parsedLayouts" :key="layout.id">
      <SlideThumbnail :slide="layout" @click="selectLayout(layout)" />
      <small class="text-gray-500 text-center ml-1"> {{ t(`slides_editor.layouts.${layout.slug}`) }} </small>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue'
import SlideThumbnail from '../SlideThumbnail.vue'
import { useSlideUpdate } from '../../../composables/useSlideUpdate'
import { useSidePanelHelpers } from '../../../composables/useSidePanelHelpers'
import { useConfirmationDialog } from '../../../composables/useConfirmationDialog'
import { t } from '@/libs/i18n'

export default {
  name: 'LayoutForm',
  components: {
    SlideThumbnail
  },
  setup() {
    const currentSlide = inject('currentSlide')
    const parsedLayouts = inject('parsedLayouts')
    const { updateSlide } = useSlideUpdate()
    const { closeSidePanel, replaceInStack } = useSidePanelHelpers()

    const selectLayout = async (layout) => {
      const confirmation = await useConfirmationDialog({
        title: t('slides_editor.components.layout_form.confirmation.title'),
        body: t('slides_editor.components.layout_form.confirmation.body'),
        confirmBtnText: t('slides_editor.components.layout_form.confirmation.confirm'),
        cancelBtnText: t('slides_editor.components.layout_form.confirmation.cancel')
      })

      if (confirmation) {
        updateSlide(currentSlide.value.layout_path, { slide: { slide_layout_id: layout.id } })

        if (layout.blocks.some(block => block.block_type === 'section')) {
          replaceInStack({
            content: {
              title: t('slides_editor.components.layout_form.add_question'),
              component: 'VariantPicker',
              props: {}
            }
          })
        } else {
          closeSidePanel()
        }
      }
    }

    return {
      selectLayout,
      parsedLayouts,
      t
    }
  }
}
</script>

<style scoped>
  .thumbnail-item {
    transition: border 0.3s ease-in-out;

    @apply cursor-pointer border-2 border-transparent;
  }

  .thumbnail-item:hover {
    border: 2px solid #8ee5fb;
  }

</style>
